<template>
  <div class="d-flex justify-center flex-gap-8">
    <div>
      <span>{{ $t("quoteInfo.side") }}</span>
      <v-radio-group
        v-model="side"
        class="mt-0"
        @change="onSideChange"
        row
        mandatory
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio :label="$t('quoteInfo.buy').toUpperCase()" value="BUY">
        </v-radio>
        <v-radio :label="$t('quoteInfo.sell').toUpperCase()" value="SELL">
        </v-radio>
      </v-radio-group>
    </div>
    <div>
      <span>{{ $t("quoteInfo.ccy") }}</span>
      <v-radio-group
        v-model="ccy"
        class="mt-0"
        @change="onCurrencyChange"
        mandatory
        row
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio label="USD" value="USD"> </v-radio>
        <v-radio label="EUR" value="EUR"> </v-radio>
      </v-radio-group>
    </div>
    <!--settlement or maturity-->
    <div>
      <span>{{ $t("quoteInfo.settlement") }}</span>
      <v-radio-group
        v-model="settlement"
        @change="onSettlementChange"
        class="mt-0"
        mandatory
        row
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio  label="D+0" value="d+0"> </v-radio>
        <v-radio  label="D+1" value="d+1">  </v-radio>
        <v-radio label="D+2" value="d+2"> </v-radio>
      </v-radio-group>
    </div>
    <!--operations-->
    <div>
      <span>Operations</span>
      <v-select v-if="role === 'pro'" :items="operationListNotSynced"
                :key="operationsList.id"
                item-text="alias"
                item-value="id"
                return-object 
                @change="onOperationChange" v-model="operation"  dense/>

      <v-select v-else :items="namedOperationsList"
                :key="operationsList.id+'broker'"
                :item-text="item => `Name: ${item.companyName} - Operation: ${item.alias}`"
                item-value="id"
                return-object 
                @change="onOperationChange" v-model="operation"  dense/>
    </div>
  </div>
</template>

<script>
import { useExecutionStore } from '@/store';
import { mapActions } from 'pinia';
export default {
  props: ["loadingNewRfq", "gridActive", "operationList", "preselectOperationId"],
  emits: ["ccy", "side", "settlement"],
  data() {
    return {
      side: undefined,
      ccy: undefined,
      settlement: undefined,
      operation: undefined,
      operationsList:[],
      role: undefined,
      namedOperationsList:[],
      preselected: false
    };
  },
  mounted(){
    // this.operationsList = JSON.parse(localStorage.getItem("operation") || "[]")
    this.$emit('operation', null)
    this.role = localStorage.getItem('userRole')
  },
  watch: {
    operationList: {
      async handler (newVal) {
        this.operationsList = newVal
        const results = await Promise.all(newVal.map(op=>this.getCompanyById(op.companyId)))
        this.namedOperationsList = newVal.map((op,id)=>({
          ...op,
          companyName: results[id]?.data?.name || '-'
        }))
        this.namedOperationsList = this.namedOperationsList.filter(op=>op.rfqId === null && op.amlCheck)

        if (this.preselectOperationId && !this.preselected) {
          const match = this.role === 'pro'
            ? this.operationListNotSynced.find(op => op.id === this.preselectOperationId)
            : this.namedOperationsList.find(op => op.id === this.preselectOperationId)
          if (match) {
            this.preselected = true
            this.operation = match
            this.onOperationChange(match)
          }
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions(useExecutionStore, [ 'getCompanyById']),
    onSettlementChange(val) {
      this.$emit("settlement", val);
    },
    onSideChange(val) {
      this.$emit("side", val);
    },
    onCurrencyChange(val) {
      this.$emit("ccy", val);
    },
    onOperationChange(val)
    {
      this.$emit('operation', val)
    }
  },
  computed:{
    operationListNotSynced(){
      return this.operationList.filter(op=>op.rfqId === null && op.amlCheck)
    }
  }
};
</script>
